type CustomerTheme = {
  scssFile: () => Promise<any>;
  theme: string;
}

const CUSTOMER_SCSS: Record<string, CustomerTheme> = {
  socan: {
    scssFile: () => import('../styles/environments/custom/socan.scss'),
    theme: 'theme-socan',
  },
};

export const applyCustomerStyles = async (customer: string) => {
  const key = customer.toLowerCase();
  const customerStyles = CUSTOMER_SCSS[key];

  if (!customerStyles) return;

  await customerStyles.scssFile();
  document.body.classList.add(customerStyles.theme);
};